import { SharingAdapter } from '@components/common/Sharing';
import React from 'react';
import useShare from './useShare';

// TODO: implementate save mutation for share
// to eventually remove the saga layer

function Share({ config, ...rest }) {
  const { data }: any = useShare({ config });
  const { url } = config;

  return (
    <SharingAdapter
      url={url}
      config={data.config}
      {...rest}
    />
  )
}

export default Share;
